import { CaretRightOutlined } from "@ant-design/icons";
import { Button, Collapse } from "antd";
import React, { Fragment } from "react";
import { Rate } from "antd";
import ViewRatings from "../../Model/ViewRatings";
import { formatProfileTitle } from "../../Utils";

import { awardTypesIcons } from "../../../Config/helpers/constants";
import { useNavigate } from "react-router-dom";

const { Panel } = Collapse;
const eventAwards = (data) => {
  return (
    <div className="timelineiconpadding">
      {data?.awardsDetail?.length > 0 ? (
        data?.awardsDetail?.map((award) => {
          return (
            <p key={award?._id} className="timelineiconpadding flexcenter">
              <img
                alt=""
                className="timelineiconplacecenter"
                src={`/images/icons/${
                  awardTypesIcons.includes(award?.awardType) ? `${award?.awardType}` : "certificate"
                }.svg`}
                height="25px"
                width="25px"
              />

              <div>
                <p className="p-0 m-0"> {award?.title}</p>
                <p className="p-0 m-0"> Rank: {award?.rank}</p>
                {award?.awardValue && <p className="p-0 m-0">Cash: {award?.awardValue} </p>}
              </div>
            </p>
          );
        })
      ) : (
        <p>No Awards found</p>
      )}
    </div>
  );
};

const ProfileBioAccordian = ({
  Rating,
  type,
  id,
  data,
  sportType,
  current,
  profile,
  isOrganizer
}) => {
  const navigate = useNavigate();

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={["Rating"]}
      expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      className="site-collapse-custom-collapse  sideItem">
      <Panel header="About" key="1" className="site-collapse-custom-panel">
        <div style={{ fontSize: "12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <h1 className="fs-14">{formatProfileTitle(current)}</h1>
            <h1 style={{ color: "#0085FF" }} className="fs-14">
              {sportType
                ? `${profile?.typeofsports || "SportType"}_${
                    profile?.nameofsports || profile?.sportsyouplay || "SportsYouPlay"
                  }`
                : " "}
            </h1>
          </div>
          <p>
            {profile?.description
              ? profile.description
              : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ipsum aenean suspendisse eget eu"}
          </p>
          <hr />
          {type && (
            <>
              <h1 className="mt-3 fs-14">Rating</h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                  fontWeight: "500"
                }}>
                {parseFloat(Rating || 0).toFixed(1)}
                <Rate
                  disabled
                  allowHalf
                  value={Rating || 0}
                  defaultValue={Rating || 0}
                  style={{ fontSize: "24px", marginLeft: "10px" }}
                />
              </div>
              {type && id ? <ViewRatings type={type} id={id} /> : null}
            </>
          )}
          {!isOrganizer && (
            <div className="mt-3">
              <h1 className=" fs-14">Awards & Achievements</h1>
              {type === "event" ? (
                eventAwards(data)
              ) : (
                <>
                  {" "}
                  <p className="timelineiconpadding flexcenter">
                    <img
                      alt=""
                      className="timelineiconplacecenter"
                      src="/images/icons/moneycolor.png"
                      height="25px"
                      width="25px"
                    />
                    <span className="sideItemsText">
                      {profile?.totalCash ||
                        profile?.data?.totalCash ||
                        profile?.teamAwardsDetails?.totalCash ||
                        0}{" "}
                      Rs ( Winning Team )
                    </span>
                  </p>
                  <p className="timelineiconpadding flexcenter">
                    <img
                      alt="img"
                      className="timelineiconplacecenter"
                      src="/images/icons/badge.png"
                      height="32px"
                      width="23px"
                    />

                    <span className="sideItemsText">
                      {" "}
                      {profile?.totalCertificates ||
                        profile?.data?.totalCertificates ||
                        profile?.teamAwardsDetails?.totalCertificates ||
                        0}{" "}
                      Certificates
                    </span>
                  </p>
                  <p className="timelineiconpadding flexcenter">
                    <img
                      alt=""
                      className="timelineiconplacecenter"
                      src="/images/icons/badge-1.png"
                      height="25px"
                      width="23px"
                    />
                    <span className="sideItemsText">
                      {" "}
                      {profile?.totalShields ||
                        profile?.data?.totalShields ||
                        profile?.teamAwardsDetails?.totalShields ||
                        0}{" "}
                      Shields ( Winning Team ){" "}
                    </span>
                  </p>
                </>
              )}
              {/* Only show this button when event is not yet completed  */}
              {type === "event" && data?.awardsDetail?.length > 0 && !data?.complete && (
                <Button
                  onClick={() => navigate(`/view/event/${data?._id}/event-awards`)}
                  style={{
                    width: "35%",
                    margin: "auto"
                  }}
                  className="registerbutton btnMobileDimensions"
                  type="primary">
                  Show More
                </Button>
              )}
            </div>
          )}
        </div>
      </Panel>
    </Collapse>
  );
};

export default ProfileBioAccordian;
